import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeCalculator: 'sipCalc',
  chartData: {
    'personalLoanCalc': [
      { label: 'principle', value: 0 },
      { label: 'intrestAmount', value: 0 },
      // { label: 'EMI', value: 0 },
      { label: 'totalAmount', value: 0 },
    ],
    'FDCalc': [
      { label: 'totalInvestment', value: 0 },
      { label: 'estimateReturn', value: 0 },
      { label: 'totalValue', value: 0 },
    ],
    'RDCalc': [
      { label: 'totalInvestment', value: 0 },
      { label: 'estimateReturn', value: 0 },
      { label: 'totalValue', value: 0 },
    ],
    'educationLoanCalc': [
      { label: 'principle', value: 0 },
      { label: 'intrestAmount', value: 0 },
      // { label: 'EMI', value: 0 },
      { label: 'totalAmount', value: 0 },
    ],
    'creditCardPayoffCalc': [
      { label: 'loanAmount', value: 0 },
      { label: 'intrestAmount', value: 0 },
      { label: 'totalPayment', value: 0 },

    ],
    'businessLoanCalc': [
      { label: 'principle', value: 0 },
      { label: 'intrestAmount', value: 0 },
      // { label: 'EMI', value: 0 },
      { label: 'totalAmount', value: 0 },
    ],
    'earlyLoanCalc': [
      { label: 'principle', value: 0 },
      { label: 'totalIntrest', value: 0 },
      { label: 'remainingPrinciple', value: 0 },

    ],
    'DTICalc': [
      { label: 'monthlyDebt', value: 0 },
      { label: 'remainingIncome', value: 0 },

    ],
    'netWorthCalc': [
      { label: 'totalAssets', value: 0 },
      { label: 'totalLiabilities', value: 0 },

    ],
    'GSTCalc': [
      { label: 'principle', value: 0 },
      { label: 'gstAMoount', value: 0 },
      { label: 'totalAmount', value: 0 },

    ],
    'VatCalc': [
      { label: 'principle', value: 0 },
      { label: 'vatAmount', value: 0 },
      { label: 'totalAmount', value: 0 },
    ],
    'salaryCalc': [
      { label: 'anualSalary', value: 0 },
      { label: 'totalHour ', value: 0 },
    ],

    'pensionCalc': [
      { label: 'annuityValue', value: 0 },
      { label: 'withDrawAmount', value: 0 },
    ],
    'loanToValueCalc': [
      { label: 'principle', value: 0 },
      { label: 'intrestAmount', value: 0 },
      { label: 'totalAmount', value: 0 },

    ],
    'savingCalc': [
      { label: 'savingAmount', value: 0 },
      { label: 'totalAmount', value: 0 },

    ],
    'carCalc': [
      { label: 'carBusyCost', value: 0 },
      { label: 'carLeast', value: 0 },
    ],
    'contributionCalc': [
      { label: 'withEmploye', value: 0 },
      { label: 'withoutEmploye', value: 0 }
    ],
    'mortgageCalc': [
      { label: 'principle', value: 0 },
      { label: 'intrestAmount', value: 0 },
    ],



  },
  pensionData: {
    totalInvestment: 0,
    totalCorpus: 0,
    interestEarned: 0,
    totalTaxSaving: 0
  },
  // retirementChartData: {
  //   withMatch: [],
  //   withoutMatch: []
  // },

  carData: {
    purchasePrice: 0,
    monthlyBuyPayment: 0,
    totalInterest: 0,
    totalLeasePayments: 0,
    securityDeposit: 0,
    downPayment: 0
  },
  mortgageData: {
    remainingBalance: 0,
    newLoanAmount: 0,
    monthlyPayment: 0,
    newMonthlyPayment: 0,
    monthlySaving: 0,
    refinanceCost: 0,
    breakEvenMonths: 0,
    monthsElapsed: 0,
    mortgagePointsCost: 0,
    cashAdjustment: 0,
  },
  contributionChart: {
    withEmployerMatch: 0,
    withoutEmployerMatch: 0,
    chartDataWithMatch: [],
    chartDataWithoutMatch: []
  },
  isContributionChartCalc : false

};

const calculatorSlice = createSlice({
  name: 'calculator',
  initialState,
  reducers: {


    setActiveCalculator: (state, action) => {
      state.activeCalculator = action.payload;
    },
    setChartData: (state, action) => {
      state.chartData = action.payload;
    },
    updatePersonalLoanChart: (state, action) => {
      const { loanAmount, totalInterest, emi, totalPayment } = action.payload;
      state.chartData['personalLoanCalc'] = [
        { label: 'principle', value: loanAmount },
        { label: 'intrestAmount', value: totalInterest },
        // { label: 'EMI', value: emi },
        { label: 'totalAmount', value: totalPayment },
      ];

    },
    updatedFdChart: (state, action) => {
      const { investAmount, estReturn, totalAmount } = action.payload;
      state.chartData['FDCalc'] = [
        { label: 'totalInvestment', value: investAmount },
        { label: 'estimateReturn', value: estReturn },
        { label: 'totalValue', value: totalAmount },
      ];
    },

    updatedRdChart: (state, action) => {
      const { investAmount, estReturn, totalAmount } = action.payload;
      state.chartData['RDCalc'] = [
        { label: 'totalInvestment', value: investAmount },
        { label: 'estimateReturn', value: estReturn },
        { label: 'totalValue', value: totalAmount },
      ];
    },
    updatedEducationChart: (state, action) => {
      const { loanAmount, totalInterest, emi, totalPayment } = action.payload;

      state.chartData['educationLoanCalc'] = [
        { label: 'principle', value: loanAmount },
        { label: 'intrestAmount', value: totalInterest },
        // { label: 'EMI', value: emi }, 
        { label: 'totalAmount', value: totalPayment },
      ];
    },
    updatedCreditChart: (state, action) => {
      const { loanAmount, totalInterest, totalPayment } = action.payload;
      state.chartData['creditCardPayoffCalc'] = [
        { label: 'loanAmount', value: loanAmount },
        { label: 'intrestAmount', value: totalInterest },
        { label: 'totalPayment', value: totalPayment },
      ]
    },
    updatedBussinessChart: (state, action) => {
      const { loanAmount, totalInterest, emi, totalPayment } = action.payload;
      state.chartData['businessLoanCalc'] = [
        { label: 'principle', value: loanAmount },
        { label: 'intrestAmount', value: totalInterest },
        { label: 'totalAmount', value: totalPayment },


      ];
    },
    updatedEarlyLoanChart: (state, action) => {
      const { loanAmount, totalInterest, totalPayment, prePaymentAmount } = action.payload;
      state.chartData['earlyLoanCalc'] = [
        { label: 'principle', value: loanAmount },
        { label: 'totalIntrest', value: totalInterest },
        { label: 'remainingPrinciple', value: loanAmount - prePaymentAmount },
      ];
    },
    updatedDtiChart: (state, action) => {
      const { totalMonthlyDebt, remainingIncome } = action.payload;
      state.chartData['DTICalc'] = [
        { label: 'monthlyDebt', value: totalMonthlyDebt },
        { label: 'remainingIncome', value: remainingIncome },
      ];
    },
    updatedNetWorthChart: (state, action) => {
      const { totalAssets, totalLiabilities } = action.payload;
      state.chartData['netWorthCalc'] = [
        { label: 'totalAssets', value: totalAssets },
        { label: 'totalLiabilities', value: totalLiabilities },
      ];
    },
    updatedGstChart: (state, action) => {
      const { totalAmount, gstAmmount, totalPrinciple } = action.payload;
      state.chartData['GSTCalc'] = [
        { label: 'principle', value: totalPrinciple },
        { label: 'gstAMoount', value: gstAmmount },
        { label: 'totalAmount', value: totalAmount },
      ]
    },
    updatedVatChart: (state, action) => {
      const { totalAmount, vatAmmount, totalPrinciple } = action.payload;
      state.chartData['VatCalc'] = [
        { label: 'principle', value: totalPrinciple },
        { label: 'vatAmount', value: vatAmmount },
        { label: 'totalAmount', value: totalAmount },
      ]
    },
    updateSalaryCalculation: (state, action) => {
      const { annualSalary, totalHours } = action.payload;
      state.chartData['salaryCalc'] = [
        { label: 'anualSalary', value: annualSalary },
        { label: 'totalHour', value: totalHours },

      ]
    },
    updatedPensionChart: (state, action) => {
      const { totalInvestment, totalCorpus, interestEarned, totalTaxSaving, annuityValue, lumpsumValue } = action.payload;
      state.chartData['pensionCalc'] = [
        { label: 'annuityValue', value: annuityValue },
        { label: 'withDrawAmount', value: lumpsumValue },
      ];
      state.pensionData = {
        totalInvestment,
        totalCorpus,
        interestEarned,
        totalTaxSaving
      };
    },
    updateLtvChart: (state, action) => {
      const { principalAmount, interestAmount, totalAmount, monthlyEmi } = action.payload;
      state.chartData['loanToValueCalc'] = [
        { label: 'principle', value: principalAmount },
        { label: 'intrestAmount', value: interestAmount },
        { label: 'totalAmount', value: totalAmount },
      ];
    },
    updateSavingsCalculation: (state, action) => {
      const { monthlyInvestment, futureValueOfExistingInvestment } = action.payload;
      state.chartData['savingCalc'] = [
        { label: 'savingAmount', value: monthlyInvestment },
        { label: 'totalAmount', value: futureValueOfExistingInvestment },
      ];
    },
    updatedCarChart: (state, action) => {
      const { carBuyCost, carLeaseCost, purchasePrice, monthlyBuyPayment, totalInterest, totalLeasePayments, securityDeposit, downPayment } = action.payload;
      state.chartData['carCalc'] = [
        { label: 'carBusyCost', value: carBuyCost },
        { label: 'carLeast', value: carLeaseCost }
      ];
      state.carData = {
        purchasePrice,
        monthlyBuyPayment,
        totalInterest,
        totalLeasePayments,
        securityDeposit,
        downPayment
      };
    },
    updatedContributionChart: (state, action) => {
      const { withEmployerMatch, withoutEmployerMatch, chartDataWithMatch, chartDataWithoutMatch } = action.payload;

      state.chartData['contributionCalc'] = [
        { label: 'withEmploye', value: withEmployerMatch },
        { label: 'withoutEmploye', value: withoutEmployerMatch }
      ];

      state.contributionChart = {
        withEmployerMatch, withoutEmployerMatch, chartDataWithMatch, chartDataWithoutMatch
      }
    },


    updatedMortgageChart: (state, action) => {
      const { totalInterest, totalPrinciple, remainingBalance,
        newLoanAmount,
        monthlyPayment,
        newMonthlyPayment,
        monthlySaving,
        refinanceCost,
        breakEvenMonths,
        monthsElapsed,
        mortgagePointsCost,
        cashAdjustment
      } = action.payload;
      if (totalInterest !== undefined && totalPrinciple !== undefined) {
        state.chartData['mortgageCalc'] = [
          { label: 'principle', value: totalPrinciple },
          { label: 'intrestAmount', value: totalInterest },
        ];
      }
      state.mortgageData = {
        remainingBalance,
        newLoanAmount,
        monthlyPayment,
        newMonthlyPayment,
        monthlySaving,
        refinanceCost,
        breakEvenMonths,
        monthsElapsed,
        mortgagePointsCost,
        cashAdjustment
      }
    },
    setContributionCartCalc: (state, action) => {
      state.isContributionChartCalc= action.payload
    },
    resetChartData: (state) => {
      return initialState;
    },

  },
});

export const { setActiveCalculator, setChartData, updatePersonalLoanChart,
  updatedFdChart,
  updatedRdChart,
  updatedEducationChart,
  updatedBussinessChart,
  updatedCreditChart,
  updatedEarlyLoanChart,
  updatedDtiChart,
  updatedNetWorthChart,
  updatedVatChart,
  updateSalaryCalculation,
  updatedGstChart,
  updatedPensionChart,
  updateLtvChart,
  updatedContributionChart,
  updatedCarChart,
  updateSavingsCalculation,
  updatedMortgageChart,
  resetChartData,
  setContributionCartCalc
} = calculatorSlice.actions;

export default calculatorSlice.reducer;